
export const unixTimestampToDate = (unix_timestamp) => {
    let date = new Date(parseInt(unix_timestamp) * 1000)
    return date.toDateString()
}

import { currencyFormatter } from '@/app/_lib/config/currency'

export const toCurrency = (text) => {
    if ( ! text) {
        return '$0.00'
    }
    return currencyFormatter.format(text)
}

export const checkboxToBoolean = (value = false) => {
    if (value == 'on') {
        return true
    } else {
        return false
    }
}

export const stringExists = (string) => {
    if (typeof string == 'string' && string !== '') {
        return true
    } else {
        return false
    }
}

export const nltobr = (text) => {
    return text.replace(/\n/g, '<br />');
}

const NAMED_ENTITIES = {
    amp: '&', lt: '<', gt: '>', quot: '"', apos: "'",
    nbsp: ' ', copy: '©', reg: '®', trade: '™',
    deg: '°', times: '×', divide: '÷',
    plusmn: '±', frac12: '½', frac14: '¼', frac34: '¾',
    hellip: '…', mdash: '—', ndash: '–',
    lsquo: '‘', rsquo: '’', ldquo: '“', rdquo: '”',
    laquo: '«', raquo: '»', sbquo: '‚', bdquo: '„',
    middot: '·', bull: '•',
}

/**
 * Decode HTML entities in a string to their character equivalents.
 * Returns a plain string — safe to render via standard JSX text interpolation
 * (React escapes any remaining special characters automatically).
 *
 * Handles named entities (e.g. &deg;), decimal refs (&#176;), and hex refs (&#xB0;).
 * Unknown named entities are left untouched.
 *
 * @param {string} str
 * @returns {string}
 */
export const decodeEntities = (str) => {
    if (typeof str !== 'string' || str.indexOf('&') === -1) return str
    return str
        .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => {
            try { return String.fromCodePoint(parseInt(hex, 16)) } catch { return _ }
        })
        .replace(/&#([0-9]+);/g, (_, dec) => {
            try { return String.fromCodePoint(parseInt(dec, 10)) } catch { return _ }
        })
        .replace(/&([a-zA-Z][a-zA-Z0-9]*);/g, (match, name) => {
            return Object.prototype.hasOwnProperty.call(NAMED_ENTITIES, name)
                ? NAMED_ENTITIES[name]
                : match
        })
}

export const getImageDimensions = async (imageUrl) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            resolve({ width: img.width, height: img.height });
        };
        img.onerror = reject;
        img.src = imageUrl;
    });
}

export const round = (num, decimalPlaces = 0) => {
    var p = Math.pow(10, decimalPlaces);
    var n = (num * p) * (1 + Number.EPSILON);
    return Math.round(n) / p;
}

export const formatStripeAmount = (amount) => {
    let newAmount = amount * 100
    return round(newAmount, 0)
}

/**
 * Wraps a promise to ensure it takes at least a minimum duration.
 * Useful for ensuring loading spinners display long enough to be visible.
 *
 * @param {Promise} promise - The promise to wrap
 * @param {number} minMs - Minimum duration in milliseconds (default: 1000)
 * @returns {Promise} - Resolves with the original promise's result after minMs
 */
export const withMinDuration = async (promise, minMs = 1000) => {
    const [result] = await Promise.all([
        promise,
        new Promise(resolve => setTimeout(resolve, minMs))
    ])
    return result
}

